<div class="my-calcs">
  <header class="my-calcs__head">
    <div>
      <h1>{{ t('calcSections.myCalculations', 'Мои расчёты') }}</h1>
      <p class="my-calcs__sub" *ngIf="calculationsPage?.totalElements as total">
        {{ t('myCalcs.count', 'Всего расчётов: {n}').replace('{n}', '' + total) }}
      </p>
    </div>
    <button type="button" class="btn-new" (click)="onCreateCalculation()">
      <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 4v12M4 10h12"/></svg>
      {{ t('myCalcs.new', 'Новый расчёт') }}
    </button>
  </header>

  <!-- Поиск всегда под рукой, даты — по запросу -->
  <form class="my-calcs__search" (ngSubmit)="applyFilters()">
    <div class="search-field">
      <svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="9" cy="9" r="5.5"/><path d="M13.5 13.5L17 17"/></svg>
      <input type="search" name="title" [(ngModel)]="title" [placeholder]="t('myCalcs.searchPlaceholder', 'Товар или номер расчёта')" (search)="applyFilters()" />
    </div>
    <button type="button" class="btn-filter" [class.btn-filter--on]="filtersOpen || hasDateFilter" (click)="filtersOpen = !filtersOpen" [attr.aria-expanded]="filtersOpen">
      <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M3 5h14M6 10h8M9 15h2"/></svg>
      <span>{{ t('myCalcs.period', 'Период') }}</span>
    </button>
    <div class="my-calcs__dates" *ngIf="filtersOpen">
      <label>
        <span>{{ t('myCalcs.from', 'С') }}</span>
        <input type="date" name="dateFrom" [(ngModel)]="dateFrom" />
      </label>
      <label>
        <span>{{ t('myCalcs.to', 'По') }}</span>
        <input type="date" name="dateTo" [(ngModel)]="dateTo" />
      </label>
      <button type="submit" class="btn-apply">{{ t('myCalcs.apply', 'Показать') }}</button>
      <button type="button" class="btn-link" *ngIf="hasActiveFilters" (click)="clearFilters()">{{ t('myCalcs.reset', 'Сбросить') }}</button>
    </div>
  </form>

  <div *ngIf="loading" class="my-calcs__state">{{ t('common.loading', 'Загрузка...') }}</div>
  <div *ngIf="error" class="my-calcs__state my-calcs__state--error" role="alert">{{ error }}</div>
  <div *ngIf="actionError" class="my-calcs__notice" role="alert">{{ actionError }}</div>

  <!-- Пусто: либо ещё нет расчётов, либо ничего не нашлось по фильтру -->
  <div *ngIf="!loading && !error && shownCalculations.length === 0" class="my-calcs__empty">
    <ng-container *ngIf="hasActiveFilters; else firstCalc">
      <p>{{ t('myCalcs.notFound', 'По этим условиям расчётов нет') }}</p>
      <button type="button" class="btn-link" (click)="clearFilters()">{{ t('myCalcs.reset', 'Сбросить') }}</button>
    </ng-container>
    <ng-template #firstCalc>
      <strong>{{ t('myCalcs.emptyTitle', 'Здесь будут ваши расчёты') }}</strong>
      <p>{{ t('myCalcs.emptyText', 'Добавьте товары или загрузите инвойс — платформа подберёт коды ТН ВЭД и посчитает таможенные платежи.') }}</p>
      <button type="button" class="btn-new" (click)="onCreateCalculation()">{{ t('myCalcs.new', 'Новый расчёт') }}</button>
    </ng-template>
  </div>

  <ul class="calc-list" *ngIf="!loading && !error && shownCalculations.length > 0">
    <li *ngFor="let c of shownCalculations" class="calc-card">
      <a class="calc-card__link" [routerLink]="['/calculations', c.id, 'overview']">
        <span class="calc-card__main">
          <span class="calc-card__title">{{ displayTitle(c) }}</span>
          <span class="calc-card__meta">
            № {{ c.id }} · {{ c.createdAt | date:'dd.MM.yyyy' }}
            <ng-container *ngIf="c.products.length > 1"> · {{ t('myCalcs.goods', 'Товаров: {n}').replace('{n}', '' + c.products.length) }}</ng-container>
          </span>
        </span>
        <span class="calc-card__sum">
          <span class="calc-card__sum-label">{{ t('myCalcs.payments', 'Таможенные платежи') }}</span>
          <strong>{{ totalLabel(c) }}</strong>
        </span>
        <span class="status" [ngClass]="'status--' + (c.status || 'CREATED').toLowerCase()">{{ statusLabel(c) }}</span>
        <svg class="calc-card__chevron" viewBox="0 0 20 20" aria-hidden="true"><path d="M8 4l6 6-6 6"/></svg>
      </a>
      <button type="button" class="calc-card__delete" *ngIf="!c.status || c.status === 'CREATED'"
              (click)="askDelete(c.id)" [attr.aria-label]="t('common.delete', 'Удалить')" [title]="t('common.delete', 'Удалить')">
        <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4 6h12M8 6V4h4v2M6 6l1 10h6l1-10"/></svg>
      </button>

      <!-- Подтверждение прямо в карточке: системный confirm() блокируют встроенные браузеры -->
      <div class="calc-card__confirm" *ngIf="confirmDeleteId === c.id" role="alertdialog" [attr.aria-label]="deleteQuestion(c.id)">
        <span>{{ deleteQuestion(c.id) }}</span>
        <div class="calc-card__confirm-actions">
          <button type="button" class="btn-link" (click)="confirmDeleteId = null" [disabled]="deleting">{{ t('common.cancel', 'Отмена') }}</button>
          <button type="button" class="btn-danger" (click)="onDeleteCalculation(c.id)" [disabled]="deleting">
            {{ deleting ? t('myCalcs.deleting', 'Удаляем...') : t('common.delete', 'Удалить') }}
          </button>
        </div>
      </div>
    </li>
  </ul>

  <app-pagination
    *ngIf="!loading && calculationsPage && calculationsPage.totalPages > 1"
    [number]="calculationsPage.number"
    [totalPages]="calculationsPage.totalPages"
    [size]="calculationsPage.size"
    [totalElements]="calculationsPage.totalElements"
    [hasNext]="calculationsPage.hasNext"
    [hasPrevious]="calculationsPage.hasPrevious"
    (pageChange)="onPageChange($event)"
  ></app-pagination>
</div>
